"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetricsConfigurationList_1 = require("./_MetricsConfigurationList");
exports.ListBucketMetricsConfigurationsOutput = {
    type: "structure",
    required: [],
    members: {
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        ContinuationToken: {
            shape: {
                type: "string"
            }
        },
        NextContinuationToken: {
            shape: {
                type: "string"
            }
        },
        MetricsConfigurationList: {
            shape: _MetricsConfigurationList_1._MetricsConfigurationList,
            locationName: "MetricsConfiguration"
        }
    }
};
//# sourceMappingURL=ListBucketMetricsConfigurationsOutput.js.map